<template>
  <component 
    :is="gameViewId"
    :scores="scores.sound"
    @finish:sound="onFinishSound"
    @finish:author="onFinishAuthor"
    @nextGame="onNextGame"
  />
</template>


<script>
import Preloader from '@/components/game/Preloader';
import views from '@/components/game/play';

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import DateFilter from '@/filters/date.filter';

export default {
  name: 'Game_PlayView',

  components: {
    Preloader,
    ...views,
  },

  data: () => ({
    showHelp: false,
    scores: {},
    info: {},
  }),

  watch: {
    gameViewId(viewId) {
      if (viewId !== 'loading') return;
      this.prepareToNextGame();
    },
  },

  computed: {
    ...mapState({ completedSounds: state => state.game.completedSounds }),
    ...mapState(['gameViewId']),
  },

  methods: {
    ...mapMutations([
      'updateCompletedSounds',
      'setGameViewId',
    ]),
    ...mapActions([
      'finishGame',
      'prepareToNextGame',
      'getGameSounds',
    ]),

    async onFinishSound({ time, words }) {
      try {
        this.info = { words };
        this.info.date = DateFilter(new Date(), 'datehour', true, true);
        this.info.duration = Math.ceil((time.end - time.start) / 1000);
        this.$metrika.add(this.$metrika.consts.GAME_SOUND_FINISH);
        this.updateCompletedSounds({
          perSession: 1 + this.completedSounds.perSession,
          sameLevel: 1 + this.completedSounds.sameLevel,
          inRow: 1 + this.completedSounds.inRow,
        });
        this.setGameViewId('author');
      } catch(err) {
        console.error(err);
      };
    },

    async onFinishAuthor(authorId) {
      try {
        const payload = Object.assign({ authorId }, this.info);
        const response = await this.finishGame(payload);
        this.scores = response.scores;
        const game = { authorId };
        game.scores = _.omit(response.scores.sound, ['difficultyCoefficient', 'speedCoefficient']);
        this.$metrika.add(this.$metrika.consts.GAME_AUTHOR_FINISH, { game });
        this.setGameViewId('finish');
      } catch(err) {
        console.error(err);
      };
    },

    async onNextGame() {
      this.setGameViewId('loading');
      this.$metrika.add(this.$metrika.consts.GAME_CONTINUE);
      await this.getGameSounds({ limit: 1 });
      this.setGameViewId('sound');
    },
  },
};
</script>